import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterViewIndex from '@/views/RouterViewIndex.vue';
import i18n from '@/i18n/index.js';
Vue.use(VueRouter);

export default [
  {
    path: 'tournament-list/:pagination',
    name: 'tournament-list-index',
    component: RouterViewIndex,
    redirect: {
      name: 'tournament-list',
      params: {
        pagination: 1,
      },
    },
    meta: {
      title: i18n.t('報名比賽'),
    },
    children: [
      {
        path: '',
        name: 'tournament-list',
        query: {
          keyword: '',
        },
        params: {
          pagination: 1,
        },
        component: () => import('@/views/Event/EventList.vue'),
        meta: {
          isTournament: true,
          title: i18n.t('報名比賽'),
        },
      },
      {
        path: 'tournament-information/:id',
        name: 'tournamentInformation-index',
        component: RouterViewIndex,
        redirect: {
          name: 'tournamentInformation',
        },
        meta: {
          key: 'tournamentInformation',
          title: i18n.t('比賽內頁'),
        },
        children: [
          {
            path: '',
            name: 'tournamentInformation',
            component: () => import('@/views/Event/Event.vue'),
            meta: {
              isTournament: true,
            },
          },
          {
            path: 'tournament-sign-up',
            name: 'tournamentSignUp-index',
            component: RouterViewIndex,
            redirect: {
              name: 'tournamentSignUp',
            },
            children: [
              {
                path: '',
                name: 'tournamentSignUp',
                component: () => import('@/views/Event/EventSignUp.vue'),
                meta: {
                  key: 'signUp',
                  title: i18n.t('報名比賽'),
                  requireAuth: true,
                  requireMobile: true,
                  isTournament: true,
                },
              },
            ],
          },
          {
            path: 'tournament-sign-up-result/:paymentId',
            name: 'tournament-signU-up-result-index',
            component: RouterViewIndex,
            redirect: {
              name: 'tournamentSignUp',
            },
            children: [
              {
                path: '',
                name: 'tournament-signU-up-result',
                component: () => import('@/views/Event/SignUpResult.vue'),
                meta: {
                  title: i18n.t('報名成功'),
                  requireAuth: true,
                  requireMobile: true,
                  isTournament: true,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
